export default "__VITE_ASSET__CL21aoOx__"